import FBConfig from "../FBConfig";
import { openDB } from 'idb';
import { v4 as uuidv4 } from "uuid";

const ReadFirebaseDinein = async (new_order, new_kot, addItemToCart, setForceRenderPage1, PrintKotInvoice) => {

    const indexedDB = await openDB("FoodDo", +localStorage.getItem("IDBVersion") || 1);
    const outlet_uuid = localStorage.getItem("outlet_uuid")
    if (!outlet_uuid) return console.log("no outlet uuid found in local storage");

    const collection_path = outlet_uuid + "/raw-orders/"
    const ref = FBConfig.ref(FBConfig.db, collection_path);
    FBConfig.onChildAdded(ref, async data => {

        try {
            console.log("order received for seat : ", data.key)
            const doc = await FBConfig.get(data.ref)
            if (doc.exists()) {

                console.log("order is still available on firebase\ndeleting order")
                console.log("order ref", data.ref);
                let deletedFBDoc = await FBConfig.remove(data.ref);
                console.log("order is deleted from firebase", deletedFBDoc)

                const order = await data.val();
                const seat_orders = await JSON.parse(localStorage.getItem("onorder_seats"))

                const outletStore = indexedDB.transaction("outlet", "readonly").objectStore("outlet");
                const outlet = await outletStore.get(localStorage.getItem("outlet_uuid"));

                const menu = await (await JSON.parse(sessionStorage.getItem("generated-collection")))
                    ?.menues?.find(m => m.menu_uuid === order.menu_uuid);

                console.log("found menu : ", menu)
                const cart = await order.items.map(i => {
                    const generatedItem = addItemToCart({
                        item: menu.category_and_items
                            .find(c => c.category_uuid === i.category_uuid).menu_items
                            .find(j => j.item_uuid === i.item_uuid),
                        addons: (i.item_addons || []),
                        multi: (i.item_serving || []),
                        instuction: i.instructions,
                        qty: +i.item_qty
                    });
                    return generatedItem;
                })

                console.log("prepared cart : ", cart);
                let seat_order;
                if (seat_orders) seat_order = await seat_orders.find(s => s.seat_uuid === order.seat_uuid)

                let tx = indexedDB.transaction("running_orders", "readwrite").objectStore("running_orders");
                let order_json;
                if (seat_order) {

                    console.log("a runnning seat order found for this dinein : ", seat_order);
                    const indexeddb_order = await tx.get(seat_order.uuid);
                    console.log("found indexeddb_order : ", indexeddb_order)

                    // generate new kot order
                    order_json = await new_kot(
                        {
                            json: indexeddb_order,
                            outlet,
                            time: Date.now(),
                            buttonStatus: 0,
                            cartItems: cart
                        }
                    );
                    console.log("updated order : ", order_json)

                    await outlet.invoice_series?.forEach((s) => {
                        if (s.user_uuid === localStorage.getItem("user_uuid")) {
                            s.last_used_at = Date.now();
                            if (+s.next_kot_number < +s.kot_end)
                                s.next_kot_number = +s.next_kot_number + 1;
                            else s.next_kot_number = +s.kot_start;
                        }
                    });

                    await tx.put(order_json);
                    const outletStore = indexedDB.transaction("outlet", "readwrite").objectStore("outlet");
                    await outletStore.put(outlet)

                    let onorder_seats = await JSON.parse(localStorage.getItem("onorder_seats")) || [];
                    onorder_seats = await onorder_seats.filter(s => s.uuid !== order_json.order_uuid)
                    let object = {
                        seat_uuid: order_json.seat_uuid,
                        created_at: order_json.created_at,
                        price: order_json.order_total,
                        title: order_json.local_order_id,
                        uuid: order_json.order_uuid
                    };
                    await onorder_seats.push(object);
                    localStorage.setItem("onorder_seats", JSON.stringify(onorder_seats));
                    setForceRenderPage1(uuidv4())
                }
                else {
                    console.log("no running order found for seat : ", data.key)
                    // generate new order json
                    order_json = await new_order(
                        {
                            outlet,
                            buttonStatus: 0,
                            customerAddress: order.delivery_address,
                            order_type: 0,
                            order_uuid: uuidv4(),
                            cartItems: cart,
                            brand_uuid: menu.brand_uuid,
                            seat_uuid: order.seat_uuid
                        }
                    );
                    console.log("generated order json : ", order_json)

                    order_json.customer_mobile = "+91-" + order.user_mobile.replace("+91-", "")
                    order_json.customer_name = order.user_name

                    await outlet.invoice_series?.forEach((s) => {
                        if (s.user_uuid === localStorage.getItem("user_uuid")) {
                            s.last_used_at = Date.now();
                            s.next_order_number = +s.next_order_number + 1

                            if (+s.next_kot_number < +s.kot_end)
                                s.next_kot_number = +s.next_kot_number + 1;
                            else s.next_kot_number = +s.kot_start;
                        }
                    });

                    const tx = indexedDB.transaction("running_orders", "readwrite").objectStore("running_orders");
                    await tx.add(order_json);
                    setForceRenderPage1(uuidv4())

                    const outletStore = indexedDB.transaction("outlet", "readwrite").objectStore("outlet");
                    await outletStore.put(outlet)
                }

                if (+outlet?.kot_type !== 2) return;

                const dateFormat = await outlet?.setup?.date_format
                const kot_setup = await outlet.kot_setup
                const section_details = await outlet?.section_details

                const item_groups = await indexedDB.transaction("item_grouping", "readonly").objectStore("item_grouping")?.getAll();
                const itemsDetails = await indexedDB.transaction("item", "readonly").objectStore("item")?.getAll();
                const categoryDetails = await indexedDB.transaction("category", "readonly").objectStore("category")?.getAll();
                const paymentMode = await indexedDB.transaction("payment_modes", "readonly").objectStore("payment_modes")?.getAll();
                const seat = await indexedDB.transaction("seats", "readonly").objectStore("seats")?.get(order_json?.seat_uuid);

                PrintKotInvoice({
                    dependencies: {
                        order_json,
                        paymentMode,
                        categoryDetails,
                        kot_setup,
                        kotNumber: +order_json.order_kot_details[order_json.order_kot_details.length - 1].kot,
                        section_name: section_details?.find(i => i.section_uuid === seat?.section_uuid)?.section_name,
                        seat_name: seat?.seat_name,
                        itemsDetails,
                        dateFormat,
                    },
                    item_groups
                })
            }
            else
                console.log("seat_uuid : ", data.val().seat_uuid, ", dinein order is deleted")
        }
        catch (error) {
            console.error(error);
        }
    });

    FBConfig.onChildChanged(ref, (data) => {
    });

    FBConfig.onChildRemoved(ref, async (data) => {
        const order = await data.val();
        const deleted_dinein_orders = await JSON.parse(localStorage.getItem("deleted_dinein_orders")) || [];
        await deleted_dinein_orders.push({ seat_uuid: order.seat_uuid, created_at: order.created_at })
        localStorage.setItem("deleted_dinein_orders", JSON.stringify(deleted_dinein_orders));
    });
}

export default ReadFirebaseDinein;